var _circle, _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 282,
    viewBox: "0 0 282 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 141,
    cy: 141,
    r: 141,
    fill: "#A7A6CE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.404 137.759c-3.791-3.919-8.274-7.742-9.443-13.063-2.023-9.208 6.627-17.06 9.459-26.053 1.958-6.219.948-13.299-2.671-18.725-3.62-5.426-9.775-9.087-16.279-9.682-11.19-1.025-22.141 6.5-33.164 4.321-8.826-1.745-15.8-9.444-24.76-10.268-10.543-.97-19.291 7.716-29.358 10.986-12.043 3.912-25.099-.176-36.938-4.662-11.84-4.487-24.297-9.492-36.777-7.345-13.891 2.39-25.539 14.472-27.397 28.419-1.841 13.822 13.602 24.917.456 41.514-4.108 5.187-6.84 12.408-5.024 18.766 1.764 6.177 9.273 10.085 9.328 16.508.043 5.071-4.748 9.106-5.134 14.163-.33 4.34 2.797 8.353 6.64 10.41 3.843 2.056 8.303 2.56 12.639 3.026 0 0 42.538 2.892 64.462 2.455l103.721-2.068c3.553-.071 7.193-.159 10.504-1.448 3.31-1.29 6.28-4.05 6.784-7.562.858-5.975-5.4-11.161-4.822-17.171.739-7.673 11.565-10.633 13.625-18.063 1.456-5.25-2.06-10.538-5.851-14.458",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.075 132.045c.221 9.031 3.188 61.303 42.187 61.63 0 0 5-35.945-41.305-62.441-.406-.232-.897.221-.883.811",
    fill: "#BDD0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.739 138.5c.856 2.548 1.813 5.069 2.81 7.569q1.5 3.75 3.165 7.431a175 175 0 0 0 3.497 7.278 146 146 0 0 0 3.876 7.079 109 109 0 0 0 4.32 6.81 79 79 0 0 0 4.877 6.409l.654.764c.218.255.432.513.665.755l1.367 1.475c.947.946 1.886 1.904 2.901 2.776 2.003 1.771 4.152 3.379 6.475 4.683l.004.003a.41.41 0 1 1-.403.715l-.003-.002c-2.378-1.358-4.559-3.016-6.582-4.831-1.026-.895-1.97-1.872-2.923-2.839l-1.373-1.502c-.233-.247-.447-.509-.666-.768l-.655-.778a80 80 0 0 1-4.87-6.497 110 110 0 0 1-4.295-6.879 147 147 0 0 1-3.84-7.136 175 175 0 0 1-3.453-7.325 182 182 0 0 1-3.117-7.472c-.982-2.515-1.92-5.043-2.763-7.612a.174.174 0 0 1 .112-.219.174.174 0 0 1 .219.11z",
    fill: "#DCE5FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.988 183.921c4.083-1.461 20.61-5.494 29.811 20.615 0 0-24.245-9.407-30.263-19.367a.858.858 0 0 1 .452-1.248",
    fill: "#BDD0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.213 179.382S31.856 154.01 40.965 85.535c.152-1.141 1.575-1.58 2.348-.725 7.191 7.963 31.666 39.249 29.9 94.572",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.842 100.544c1.831 5.784 3.66 11.568 5.462 17.361.9 2.896 1.797 5.794 2.667 8.699l1.309 4.358 1.282 4.365 2.537 8.74 1.251 4.374 1.22 4.384c1.623 5.846 3.209 11.703 4.65 17.597a.153.153 0 0 1-.296.077L66.7 166.12l-1.249-4.374c-.84-2.913-1.667-5.83-2.525-8.738l-2.556-8.73-2.578-8.724-1.297-4.36-1.284-4.363c-.867-2.906-1.708-5.82-2.558-8.731-1.699-5.822-3.391-11.647-5.124-17.46a.164.164 0 0 1 .314-.096",
    fill: "#DCE5FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.744 176.05c5.792-15.103 30.683-79.75 40.881-102.06 1.069-2.337 4.429-2.228 5.348.172 6.663 17.393 19.817 69.56-44.397 103.501-1.065.562-2.262-.49-1.832-1.613",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.044 176.252a.409.409 0 0 1-.287-.704c8.801-8.563 16.433-18.914 22.685-30.767 5.004-9.488 9.141-19.955 12.294-31.108 5.372-19 6.03-33.598 6.036-33.743a.41.41 0 0 1 .822.034c-.006.146-.666 14.822-6.06 33.91-3.168 11.212-7.326 21.735-12.358 31.277-6.293 11.934-13.979 22.359-22.845 30.984a.4.4 0 0 1-.287.117",
    fill: "#DCE5FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.329 180.562c-.956.368-1.976-.359-1.954-1.381.127-5.639 1.928-21.551 17.339-33.491 13.014-10.083 19.111-16.784 21.668-20.018.54-.684 1.641-.281 1.613.589-.309 9.605-4.029 40.999-38.666 54.301",
    fill: "#BDD0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.52 179.548a.41.41 0 0 1-.367-.594c.112-.223 11.383-22.528 28.845-37.365a.41.41 0 0 1 .58.047.41.41 0 0 1-.047.578c-17.332 14.726-28.531 36.885-28.642 37.107a.41.41 0 0 1-.369.227",
    fill: "#DCE5FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.417 193.951a3 3 0 0 1-2.995 2.987H56.456a3 3 0 0 1-2.995-2.987l-1.348-92.9c0-1.642 1.94-4.85 5.493-4.608l158.29-4.088a7.56 7.56 0 0 1 5.529 2.196 7.52 7.52 0 0 1 2.216 5.508z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.459 191.086a2.84 2.84 0 0 1-2.834 2.828H60.361a2.84 2.84 0 0 1-2.833-2.828l-1.272-84.336c.15-5.075 4.608-6.899 7.31-6.791l151.707-4.063a5.303 5.303 0 0 1 5.442 5.418z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.207 150.811a.206.206 0 0 1-.206-.202l-.1-6.84a.206.206 0 0 1 .202-.208c.106.004.207.089.209.202l.1 6.84a.206.206 0 0 1-.202.208zm-.247-16.761a.205.205 0 0 1-.205-.202l-.386-26.195c.008-1.742.546-3.134 1.598-4.141 1.916-1.832 4.916-1.74 5.043-1.735l48.448-1.298a.204.204 0 0 1 .211.2.206.206 0 0 1-.2.211l-48.46 1.297c-.135-.004-2.967-.092-4.757 1.622-.97.926-1.464 2.219-1.472 3.842l.386 26.191a.204.204 0 0 1-.203.208z",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.37 186.407c.162-6.97.101-68.695-.3-74.026-.4-5.331 7.918-6.331 20.69-6.93 12.77-.6 120.524-2.976 123.299-3.2 6.236-.505 7.527 8.799 6.903 28.996-.469 15.175-1.246 40.171-1.603 51.667a6.35 6.35 0 0 1-6.341 6.148c-25.93.071-125.312.355-131.928.552-7.613.226-10.785-.443-10.72-3.207",
    fill: "#7D97F4",
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.759 204.649H44.403a.8.8 0 0 1-.797-.796v-6.57c0-.438.358-.796.797-.796h189.356c.438 0 .797.358.797.796v6.57a.8.8 0 0 1-.797.796",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.308 180.491c19.373 0 35.078-15.675 35.078-35.011s-15.705-35.011-35.078-35.011-35.078 15.675-35.078 35.011 15.705 35.011 35.078 35.011",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.619 157.203a1.35 1.35 0 0 1-1.045-.036l-24.133-11.034 1.714 14.038c.24 1.964 1.456 3.581 3.099 4.115 15.042 4.884 29.121 5.979 41.405.001 1.12-.545 1.983-1.627 2.382-2.96l4.389-14.647z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.816 135.641 37.992-15.638a1.35 1.35 0 0 1 1.028-.002l37.573 15.295c1.398.569 1.376 2.876-.032 3.408l-41.758 15.8a1.34 1.34 0 0 1-1.045-.036l-33.808-15.457c-1.332-.609-1.3-2.815.05-3.37",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.542 147.75s-8.248 11.428-.54 18.727c.277.262.689.179.867-.181l2.927-5.934c2.173-4.406-3.254-12.612-3.254-12.612",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.51 149.588h-.83v-7.684l1.569-.532z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212.389 74.764-.004-.18a.5.5 0 0 1 .17-.389c.656-.576 3.111-2.552 6.558-3.142a.43.43 0 0 1 .435.186 9 9 0 0 0-1.192.233c-1.705.43-4.19 1.593-5.967 3.292",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.356 71.472c.519-.131.905-.2 1.192-.233a.43.43 0 0 1 .006.477q-.084.136-.211.292c-.546.668-4.941 5.085-4.941 5.085s-1.384.155-1.804-.094c-.136-.08-.191-1.512-.209-2.235 1.776-1.7 4.262-2.863 5.967-3.292",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212.51 79.396.025-2.655a.52.52 0 0 1 .363-.492c.331-.103.839-.197 1.299-.02a.75.75 0 0 1 .47.65l.174 2.482z",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.082 77.146a.54.54 0 0 1 .175-.256c.557.115 1.717.433 4.092 1.296 2.753 1 3.553 1.857 3.782 2.314-1.187.334-3.882.838-7.733.048l-.759-.364s.071-1.855.443-3.038",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.348 78.186c-2.375-.863-3.535-1.18-4.092-1.296a.54.54 0 0 1 .457-.11c1.369.298 5.504 1.311 7.654 3.085a.347.347 0 0 1-.119.6l-.118.035c-.229-.457-1.029-1.315-3.782-2.314",
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221.197 81.775 1.642-1.927a.6.6 0 0 1 .652-.18c.259.087.602.266.933.632a.55.55 0 0 1 .075.624l-1.203 2.273z",
    fill: "url(#n)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.205 78.498s-1.977-.399-3.08-.03c0 0-1.532 8.665-1.31 11.458l4.272.91s.215-9.778.118-12.338",
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.494 93.537s13.99.917 19.674.58a1.57 1.57 0 0 0 1.308-.853c1.241-2.42 4.962-9.687 5.289-10.38 0 0-1.471-1.251-2.565-1.432 0 0-5.239 5.707-5.484 8.641 0 0-11.972-3.56-13.158-3.539-1.186.022-4.838 1.606-4.838 1.606z",
    fill: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.335 92.146c.196-1.641 3.231-3.21 3.231-3.21l.969-2.066a10.98 10.98 0 0 1 4.003-5.73l1.34-.992c1.316-.975 3.403-.614 4.727.35 2.941 2.14 7.302 5.723 8.791 6.956.32.265.762.327 1.143.163l.252-.109a.335.335 0 0 1 .466.348l-.693 5.808-10.17-.214c-1.22-.012-4.752-.171-5.303-1.257l-.919-2.313c-2.222 1.85-5.061 3.109-6.579 3.469-.7.166-1.349-.449-1.258-1.203",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.624 77.007 3.098 3.062a.554.554 0 0 1 .034.754c-.975 1.138-1.809 1.732-2.497 1.77a.81.81 0 0 1-.722-.388l-1.637-2.631z",
    fill: "url(#r)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.171 91.886-2.68-1.07-3.151 2.452 5.599.075z",
    fill: "url(#s)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.256 76.202s.401 3.451 1.565 4.523c1.164 1.07 3.458.294 4.255-2.297l-1.496-4.457z",
    fill: "url(#t)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.726 76.848c-.09.031-.183-.034-.195-.139-.04-.319-.14-.95-.35-1.38 0 0 .117-.451-1.015.22-1.131.673-2.831 1.66-3.82 1.054-.965-.592-1.919-3.534.639-2.966.098.022.188-.065.182-.177-.027-.482.026-1.59 1.025-1.937.934-.324 1.439.155 1.647.444a.14.14 0 0 0 .235-.003c.283-.408 1.049-1.275 2.159-.71.915.465 1.051 1.105 1.032 1.503-.006.129.109.217.214.164.283-.143.736-.215 1.163.402.592.853-.272 1.58-.531 1.77a.18.18 0 0 0-.069.14c-.007.44-.086 2.361-.95 3.437-.075.093-.212.064-.253-.052l-.641-1.773c-.03-.082-.111-.125-.186-.099z",
    fill: "url(#u)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.709 77.206s.419-1.84 1.023-1.236-.177 1.915-.878 2.16z",
    fill: "url(#v)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.2 83.935s-.085-3.708 1.441-3.768c1.896-.075 4.928 1.325 3.063 6.741-1.03 2.993-2.561 5.206-6.714 6.11a6.1 6.1 0 0 0-1.373-3.193c1.7-1.171 3.148-3.008 3.583-5.89",
    fill: "url(#w)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.806 89.838a.15.15 0 0 0 .085-.026c1.958-1.35 3.055-3.21 3.454-5.855l.001-.025c-.022-.991.168-3.573 1.299-3.617a3.7 3.7 0 0 1 1.613.306.149.149 0 0 0 .121-.271 4 4 0 0 0-1.746-.331c-1.621.063-1.589 3.621-1.584 3.907-.387 2.552-1.445 4.345-3.327 5.642a.15.15 0 0 0-.038.206.15.15 0 0 0 .122.064",
    fill: "url(#x)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.311 92.806a.2.2 0 0 0 .049-.007c3.449-1.152 4.674-3.489 5.485-5.842.183-.533.326-1.047.424-1.528a.149.149 0 0 0-.291-.059c-.095.468-.235.97-.414 1.49-.786 2.282-1.971 4.547-5.299 5.657a.148.148 0 0 0 .046.29",
    fill: "url(#y)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.395 93.317.02-1.438s4.037.127 7.201-2.053a6.1 6.1 0 0 1 1.373 3.192c-2.102.458-4.874.58-8.594.299",
    fill: "url(#z)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166.911 82.909 7.615.283a1.45 1.45 0 0 1 1.282.88l2.444 5.715a1.286 1.286 0 0 1-1.233 1.79l-7.432-.276a.88.88 0 0 1-.8-.588l-2.472-6.995a.607.607 0 0 1 .596-.81",
    fill: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.133 86.928c.146.518.006 1.01-.313 1.1s-.696-.258-.842-.775c-.146-.518-.006-1.01.313-1.1s.697.257.842.775",
    fill: "url(#B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.238 87.8s.873-1.122 1.599-1.16c.726-.039.529 1.523-.026 2.682s-1.311-.387-1.573-1.521",
    fill: "url(#C)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.16 190.947h-1.267v13.689h1.268z",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.973 204.9H68.08v-.472a.353.353 0 0 0-.353-.352H57.326a.353.353 0 0 0-.353.352zm-1.649-14.428c0 .749.614 1.361 1.364 1.361h11.238c.75 0 1.363-.612 1.363-1.361v-1.23c0-.749-.613-1.362-1.363-1.362H56.688c-.75 0-1.364.613-1.364 1.362z",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.89 181.821s1.884.291 4.002 1.705c.334.223.517.61.466 1.008-.253 2.005-1.297 8.497-4.736 14.838a1.6 1.6 0 0 0-.153 1.095l.597 2.776 1.108 1.037H70.32l-1.9-5.133.812-.257a1.535 1.535 0 0 0 1.074-1.437l.095-5.507c-.081-2.453 1.507-4.146 1.507-4.146l-4.558-.221z",
    fill: "url(#D)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.29 204.781c.26.34-2.799.788-4.344.045 0 0-2.141-3.719-2.141-5.634 0 0 .17-.391 1.427-.302 0 0 .72 4.404 1.478 4.897.76.493 2.125.05 2.125.05s1.07.443 1.454.944",
    fill: "url(#E)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.926 187.88c.024-.042 4.908-.586 4.908-.586s-.16 1.482.34 3.523c.5 2.04 7.67 10.88 7.67 10.88l-.752 2.379c2.325.808 4.612.937 6.862.412l-4.66-2.791s-4.36-14.833-7.032-17.479l-4.895-1.691z",
    fill: "url(#F)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.973 179.25s-2.814 4.177-3.045 6.083c-.23 1.905.771 2.68 3.724 2.807 2.952.128 10.834.126 10.834.126l6.727-5.738s-4.902-1.746-6.177-2.24-12.063-1.038-12.063-1.038",
    fill: "url(#G)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.376 203.275s-.81.782-.263 1.653c0 0 6.413 1.134 8.154.62 0 0-.362-.824-2.322-1.761l.145.111a.233.233 0 0 1-.155.419c-1.292-.073-3.966-.31-5.559-1.042",
    fill: "url(#H)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.581 178.697s3.277-3.114 4.89-5.177a4.37 4.37 0 0 0 .742-3.939c-.736-2.476-2.045-5.041-2.164-5.44-.183-.612-3.857-.586-3.857-.586s-7.23 4.683-10.07 12.616l3.19.992s1.887-3.161 3.752-5.171c0 0-3.227 4.256-3.34 5.998z",
    fill: "url(#I)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.493 160.722c-.038.127-.997 3.3-1.072 3.366s-2.103.174-3.058-.477l1.62-3.383z",
    fill: "url(#J)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.979 156.29s.948 1.619.392 4.322-1.952 3.101-2.93 2.567c-.98-.533-2.288-1.54-2.718-3.876s3.973-5.051 5.256-3.013",
    fill: "url(#K)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.464 158.938s1.146-3.706 3.77-1.8l.292.883s2.17-.91 1.185-2.853c-.985-1.942-3.836-2.996-6.08-1.389-2.242 1.606-2.87 3.256-2.518 5.09.354 1.834 1.666 1.033 1.666 1.033s.102-1.392.725-1.712.734.711.734.711z",
    fill: "url(#L)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.927 159.046s.6-1.901-.555-1.828-.47 1.82-.161 2.45z",
    fill: "url(#M)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.257 178.928-2.407-2.316-3.331 1.404s-3.315.513-5.212 0l-1.898-.512-4.287-1.333-.674 1.9c-.17.482.001 1.018.419 1.314.371.263.806.552 1.083.673.565.247 13.919-.17 13.919-.17z",
    fill: "url(#N)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.58 154.42c.57-.172.68-.932.208-1.296-1.523-1.175-4.21-2.307-7.24.668-3.415 3.35-5.304 4.925-6.3 4.836-.656-.059-1.093.653-.697 1.178.292.387.815.755 1.707 1.017 6.885 2.026 8.972-5.395 12.321-6.403",
    fill: "url(#O)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.146 180.02.032.001 13.966-.015a.625.625 0 1 0-.001-1.248l-13.966.015a.625.625 0 0 0-.03 1.247",
    fill: "url(#P)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.698 167.364h-11.63c-.859 0-1.64.495-2.006 1.269l-5.376 11.379h14.453c.553 0 1.05-.337 1.253-.85l4.17-10.53a.927.927 0 0 0-.864-1.268",
    fill: "url(#Q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.505 173.199c-.252.781-.066 1.54.416 1.695s1.076-.353 1.328-1.135c.252-.781.066-1.54-.415-1.695-.482-.155-1.077.353-1.329 1.135",
    fill: "url(#R)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.204 207.482a.5.5 0 0 0 .202-.043.526.526 0 0 0 .268-.686L87.948 181.29a.507.507 0 0 0-.672-.273.526.526 0 0 0-.267.686l10.725 25.463a.51.51 0 0 0 .47.316",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.12 207.482a.51.51 0 0 0 .47-.316l10.727-25.463a.526.526 0 0 0-.268-.686.507.507 0 0 0-.672.273l-10.726 25.463a.526.526 0 0 0 .268.686.5.5 0 0 0 .202.043m-30.153 0a.5.5 0 0 0 .202-.043.526.526 0 0 0 .268-.686L45.712 181.29a.507.507 0 0 0-.672-.273.526.526 0 0 0-.268.686l10.726 25.463a.51.51 0 0 0 .47.316",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.884 207.482a.51.51 0 0 0 .47-.316l10.726-25.463a.526.526 0 0 0-.267-.686.507.507 0 0 0-.672.273l-10.726 25.463a.526.526 0 0 0 .267.686.5.5 0 0 0 .202.043",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.628 180.529a.51.51 0 0 1 .12-.445.6.6 0 0 1 .446-.196h58.277c.226 0 .437.108.559.286a.59.59 0 0 1 .043.595l-.632 1.278a.89.89 0 0 1-.802.481H43.593a.66.66 0 0 1-.657-.508z",
    fill: "url(#S)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.121 163.105s5.648 3.122 6.116 8.408.038 27.222-11.288 32.622-26.317 4.155-32.056 3.564c-5.738-.59-8.92-4.482-9.631-7.163s-1.859-12.664 4.178-15.884 12.377-8.154 18.713-12.959 17.194-12.646 23.968-8.588",
    fill: "url(#T)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.22 186.474s1.525.081 1.712 3.211c0 0-3.535 3.163-8.31 3.915-.358.057.501-2.442.63-2.78.615-1.611 2.552-2.648 5.968-4.346",
    fill: "url(#U)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.387 182.793h-1.531a3.9 3.9 0 0 1-2.808-1.186c-2.535-2.609-8.868-8.753-13.874-10.446a1.694 1.694 0 0 0-2.069.893c-1.045 2.226-2.511 7.405.961 15.244.385.868 1.476 1.237 2.267.71a1.3 1.3 0 0 0 .488-.594l-.382-9.163s8.423 7.352 9.887 8.771c1.463 1.419 8.905.554 7.061-4.229",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.288 205.644c1.348-1.179 3.496-2.502 6.597-2.881l1.048.64s-.668.984-1.89 2.024c-1.123.651-2.856 1.533-4.293 1.724-1.398.185-1.604-.657-1.462-1.507",
    fill: "url(#V)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.253 190.82c.83.268 1.195 1.442 3.303.666a18.7 18.7 0 0 0 4.334-2.279q.026.226.042.478s-3.727 3.538-8.502 4.291a.474.474 0 0 1-.513-.639c.232-.608.65-1.529 1.336-2.517",
    fill: "url(#W)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.272 206.651c.266-.302.605-.648 1.015-1.007-.142.85.064 1.692 1.462 1.507 1.437-.191 3.171-1.073 4.293-1.724-1.407 1.198-3.548 2.469-6.25 2.395-.6-.017-.917-.721-.52-1.171",
    fill: "url(#X)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.223 172.961s-2.474 7.112-7.296 1.699l-.459-.204-3.456-2.358.385 1.366c.213.755.762 1.37 1.488 1.668l.456.187c.866 1.798 2.723 4.522 5.582 5.038 4.291.776 6.492-5.011 6.492-5.011z",
    fill: "url(#Y)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220.269 185.117-15.064.163s-8.603 7.104-10.163 17.936c0 0-.259.797 1.296.933 0 0 5.201-3.39 8.592-9.385 4.159-7.35 12.397-4.041 12.397-4.041 2.707-1.948 6.532-2.345 9.414-2.994z",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.046 184.984s1.844-5.003 2.241-9.865c0 0-1.35-1.157-2.193-1.657a.61.61 0 0 1-.238-.789c.62-1.282 4.369-6.315 4.65-6.385 1.527-.38 7.787-3.352 12.197 2.668 1.892 2.584-.376 10.537-8.961 18.773l-1.771.338z",
    fill: "url(#Z)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227.56 159.476 2.702 6.297a.41.41 0 0 1-.159.457c-.54.369-1.951 1.103-3.886.39a.61.61 0 0 1-.392-.523l-.47-4.443z",
    fill: "url(#aa)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.287 175.222a.103.103 0 0 1-.103-.103c-.008-2.258.862-5.245.871-5.275a.103.103 0 0 1 .128-.07.104.104 0 0 1 .07.128c-.009.029-.871 2.988-.864 5.217a.103.103 0 0 1-.102.103",
    fill: "url(#ab)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.001 177.059a.103.103 0 0 1-.094-.144c.016-.035 1.533-3.465 1.803-5.608a.1.1 0 0 1 .115-.089.1.1 0 0 1 .089.114c-.274 2.173-1.803 5.631-1.819 5.666a.1.1 0 0 1-.094.061",
    fill: "url(#ac)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.341 180.643-.576-.489a.1.1 0 0 1-.012-.144.103.103 0 0 1 .145-.012l.449.381c2.816-2.215 3.808-6.508 3.818-6.552a.1.1 0 0 1 .123-.077c.055.012.09.067.077.122-.01.045-1.033 4.477-3.958 6.72z",
    fill: "url(#ad)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.289 170.282-.242.332a.35.35 0 0 0 .086.499l5.445 3.713a.353.353 0 0 0 .416-.57l-5.202-4.044a.354.354 0 0 0-.503.07",
    fill: "url(#ae)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.26 181.288c-.269.021-.479.287-.477.607.007 1.059.193 3.258 1.597 3.683 1.755.532 3.747-.312 3.277-3.922-.053-.4-.348-.692-.687-.665z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.815 184.36s9.114 0 13.744-7.179l2.72 2.482s-5.444 9.31-15.694 5.821c0 0-2.367.487-3.701.118-.749-.207-1.156-.876-1.368-1.423-.123-.314.184-.625.504-.515.944.325 2.62.818 3.795.696",
    fill: "url(#af)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.289 182.132s.553-1.488 1.501-.409c.948 1.08-.592 1.908-1.501 2.026v-.393s1.061-.474.926-1.105c-.136-.631-.926.157-.926.157zm-3.401-7.348c.346.119.678.296.95.551.273.251.472.593.53.963.03.184.027.375-.02.558a1.3 1.3 0 0 1-.252.497c-.234.29-.543.484-.822.697-.278.208-.531.467-.652.79a.8.8 0 0 0-.023.498.86.86 0 0 0 .293.412c.271.223.616.331.929.504.155.09.303.194.422.329.121.132.2.306.202.486q0 .005-.005.005-.004 0-.006-.005a.73.73 0 0 0-.208-.471 1.6 1.6 0 0 0-.422-.313c-.31-.164-.662-.264-.95-.489a.93.93 0 0 1-.323-.437.87.87 0 0 1 .012-.547c.122-.35.384-.626.665-.846.279-.223.575-.423.783-.694.214-.267.288-.616.222-.947a1.52 1.52 0 0 0-.498-.857 2.4 2.4 0 0 0-.892-.489.1.1 0 0 1-.067-.128.103.103 0 0 1 .129-.067z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.887 177.646c-.175.361-.513.53-.674.801-.085.133-.128.284-.084.424.04.14.156.259.288.354.259.19.642.289.846.627a.705.705 0 0 1-.311.964.05.05 0 0 1-.067-.025.05.05 0 0 1 .025-.067c.288-.135.408-.545.243-.807-.081-.135-.217-.231-.363-.313s-.309-.15-.46-.254c-.148-.101-.297-.236-.36-.43-.067-.196-.007-.409.089-.566.196-.325.523-.508.64-.791a.1.1 0 0 1 .134-.056.1.1 0 0 1 .056.134z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.52 157.861c-.005.104 2.055 6.624 2.055 6.624l3.705-1.253-1.032-6.469s-4.66-.632-4.728 1.098",
    fill: "url(#ag)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.239 157.958a.56.56 0 0 1 .316.381l.799 3.315a.6.6 0 0 1 .015.153c-.013.285-.127 1.189-1.062 1.026-.797-.138-1.531-.254-2.042-.098a.56.56 0 0 0-.366.708c.196.611.615 1.836 1.141 2.873a.56.56 0 0 0 .713.26c.711-.293 2.084-.907 3.097-1.659a.56.56 0 0 0 .221-.532c-.133-.901-.494-3.43-.486-4.159.007-.678.767-1.17 1.133-1.368a.56.56 0 0 0 .279-.356c.119-.458.197-1.387-.987-1.668a.56.56 0 0 1-.411-.666c.114-.529.073-1.271-.896-1.589-.982-.322-1.644.212-2.006.666a.59.59 0 0 1-.675.186.37.37 0 0 0-.367.04.547.547 0 0 1-.764-.148c-.291-.44-.818-.867-1.729-.612-1.67.468-1.666 2.369-1.102 3.424.564 1.056 2.346.446 3.204-.205.63-.479 1.538-.169 1.975.028",
    fill: "url(#ah)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.868 161.453s-.903-1.881-.235-2.434 1.758-.416 1.672 1.024c-.107 1.791-1.437 1.41-1.437 1.41",
    fill: "url(#ai)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.578 169.264c-.033.063-1.04.771-1.04.771s-.7 3.846.584 5.74 5.656-1.478 5.656-1.478 2.46-.384 3.696-5.211c.284-1.108-1.489-.266-3.464-.062-2.547.263-5.432.24-5.432.24",
    fill: "url(#aj)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.433 180.159a8.4 8.4 0 0 1 2.552-1.185c.343-.093 2.193.444 3.337.417 1.571-.036 3.169-.749 4.464-.427 1.285.32 2.338.738 2.945 1.169 1.819 1.291 2.887 3.699 3.538 6.083-1.232 1.263-2.783 1.824-2.783 1.824l-.287 11.592-6.867 3.507-7.838-3.928.28-11.328s-2.489-1.157-2.671-1.578c-.183-.421 1.134-4.639 3.33-6.146",
    fill: "url(#ak)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.218 186.254s-3.335 9.23 4.271 13.023c1.579-.209.972-2.827.972-2.827s-3.305-.73-2.312-8.429c-.914-.751-2.931-1.767-2.931-1.767",
    fill: "url(#al)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.109 186.254s2.295 9.635-4.27 13.023c-1.58-.209-.972-2.827-.972-2.827s2.663-1.309 2.312-8.429c.914-.751 2.93-1.767 2.93-1.767",
    fill: "url(#am)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.386 199.926h-12.904a1.08 1.08 0 0 1-1.078-1.076v-7.999a1.08 1.08 0 0 1 1.078-1.076h12.904a1.08 1.08 0 0 1 1.078 1.076v7.999a1.08 1.08 0 0 1-1.078 1.076",
    fill: "url(#an)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.823 192.524c.079.538-.21 1.027-.749 1.107a.987.987 0 0 1-1.122-.831c-.08-.538.167-1.073.707-1.153s1.084.338 1.164.877",
    fill: "url(#ao)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.069 202.935c-1.724-.395-5.707-.183-5.707-.183l-.162.438-.268 2.177s3.793.682 5.663.681q.286-.002.524-.079.086-.076.166-.161c.793-.865.564-2.135-.216-2.873",
    fill: "url(#ap)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.217 202.63.674.029c.362.015.704.191.948.489.243.297.369.69.347 1.091-.017.32-.148.618-.365.83-.216.212-.5.32-.789.3l-1.032-.074z",
    fill: "url(#aq)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.538 202.726c1.732-.342 5.709-.008 5.709-.008l.151.443.213 2.184s-3.809.566-5.678.507a1.8 1.8 0 0 1-.522-.094 2 2 0 0 1-.161-.167c-.772-.889-.511-2.151.288-2.865",
    fill: "url(#ar)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.395 202.63-.675.008c-.363.005-.709.17-.96.46s-.386.679-.375 1.081c.009.319.133.622.344.841.212.218.493.335.782.323l1.033-.042z",
    fill: "url(#as)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.55 196.111c-.782-1.795-2.693-2.087-4.32-1.247-.029.037-10.333 5.308-19.419 7.618.26.832.393 1.718.423 2.589a6 6 0 0 1-.01.574c6.969-.358 14.531-2.677 21.03-4.716 2.015-.648 3.162-2.828 2.296-4.818",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.267 205.207a5.96 5.96 0 0 1 .587-2.802l.038-.117a83 83 0 0 1-2.069-.676c-6.453-2.204-11.376-4.43-16.074-6.991-1.825-.996-3.9-.329-4.484 1.827-.522 1.924.662 3.463 2.362 4.144 5.844 2.343 14.429 4.483 19.651 4.834z",
    fill: "url(#au)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.986 178.974s.694 3.002 4.063 2.939c3.432-.062 3.738-2.949 3.738-2.949l-2.242-.478-.187-2.493-3.372.249-.062 2.368z",
    fill: "url(#av)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.458 168.929s-3.864 7.471.72 9.284c3.233 1.278 5.26-4.962 4.655-6.652-.935-2.613-1.55-2.303-1.55-2.303z",
    fill: "url(#aw)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166.833 171.561-.028-.082q.021.206.024.429.01-.158.014-.316zm-.028-.083-.019-.151c.197.331-.182-.44.019.151",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.623 166.923c2.07-.47.633 5.923-2.449 4.875-3.083-1.048-4.519-1.692-4.999-.847s-1.281 4.3-1.547 2.508c-.248-1.674-.489-4.743 1.131-5.413.919-.38 1.728.444 2.362.238.976-.318 1.916-.329 2.495.005 1.097.631 1.691-1.067 3.007-1.366",
    fill: "url(#ax)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.83 172.194s-.669-1.008-.973.023c-.305 1.031-.111 2.456.501 1.793.613-.662.472-1.816.472-1.816",
    fill: "url(#ay)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.213 108.15c-.02-.007-10.848-18.934-12.311-20.715a1.14 1.14 0 0 0-1.013-.407l-3.022.36-3.55 7.667 5.915-3.439c-.586 4.04 7.013 10.045 9.619 12.236a.597.597 0 0 1 .048.87l-1.041 1.087c1.708 1.728 3.679 2.838 5.904 3.351z",
    fill: "url(#az)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.458 105.223s-.664.214-.888.804c-.108.282.008.602.254.778 1.093.782 4.7 3.306 6.364 3.801a.19.19 0 0 0 .236-.222c-.086-.385-.362-1.156-1.252-2.284l.08.161a.231.231 0 0 1-.32.305c-1.113-.628-3.381-2.001-4.474-3.343",
    fill: "url(#aA)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.996 112.796c-.018-.012-1.643-3.919-1.661-3.93-1.49-9.052-5.123-16.804-6.195-18.844a1.13 1.13 0 0 0-.91-.603l-3.032-.258-5.032 6.79 6.49-2.172c-1.393 3.839 4.832 11.254 6.94 13.926a.597.597 0 0 1-.13.862l-1.24.854c1.323 2.038 3.028 3.522 5.102 4.474z",
    fill: "url(#aB)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.934 108.968s-.694.076-1.034.608a.675.675 0 0 0 .091.814c.913.987 3.933 4.187 5.462 5.007a.188.188 0 0 0 .276-.169c-.005-.395-.12-1.206-.763-2.49l.046.174c.057.22-.204.383-.375.234-.963-.84-2.906-2.642-3.704-4.178",
    fill: "url(#aC)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.001 87.73s-2.743 4.074-2.968 5.932c-.225 1.857.758 2.5 3.63 2.737 8.545.705 12.757-1.851 12.757-1.851.585-3.72 1-4.667 5.883-6.69 0 0-6.175.49-7.418.009-1.243-.482-11.884-.136-11.884-.136",
    fill: "url(#aD)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.942 64.913s-1.911-2.257-3.942.512c-.368.501-1.781.087-2.3 1.137-.267.542-.845.85-1.44.74-1.482-.273-3.905-.296-5.102 2.023-.913 1.77-.208 2.805.705 3.396.67.433.91 1.314.505 2.001-.39.659-.462 1.551.541 2.626 2.25 2.406 6.704-1.528 6.704-1.528l3.537-8.34z",
    fill: "url(#aE)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.42 87.192s3.195-3.037 4.768-5.048a4.26 4.26 0 0 0 .724-3.84c-.718-2.414-1.994-4.915-2.11-5.304-.179-.597-3.76-.572-3.76-.572s-7.05 4.567-9.82 12.301l3.111.967s1.84-3.082 3.66-5.041c0 0-3.147 4.148-3.258 5.847z",
    fill: "url(#aF)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.508 88.39-2.4-2.607-2.773.745s-3.232.5-5.082 0l-1.85-.5-4.18-1.299-.657 1.852c-.167.47 0 .993.408 1.281.362.257.786.539 1.056.657.55.24 12.681.076 12.681.076z",
    fill: "url(#aG)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.503 68.13-2.407 4.468c.159.976 2.62 1.003 3 .42a.6.6 0 0 0 .076-.196l1.44-2.986c.062-.291-.738-1.272-1-1.412l-.958-.508c-.368-.196 1.17-.212-.15.214",
    fill: "url(#aH)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.376 67.08s.271 1.51-.918 3.43c-1.188 1.92-2.372 1.833-2.974 1.148-.601-.684-1.322-1.824-.994-3.739s4.475-2.763 4.886-.838",
    fill: "url(#aI)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.93 68.127s1.924-2.523 3.402-.323l-.025.76s1.922-.09 1.714-1.858c-.209-1.768-1.778-2.976-3.953-2.372s-3.446 1.292-3.692 2.8.988 1.26.988 1.26.47-1.04 1.04-1.11c.568-.072.363.751.363.751z",
    fill: "url(#aJ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.487 68.06s.997-1.291.09-1.56c-.908-.268-.874 1.266-.815 1.836z",
    fill: "url(#aK)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.561 89.422h.026l11.041-.011a.494.494 0 1 0-.001-.987l-11.041.012a.494.494 0 0 0-.025.986",
    fill: "url(#aL)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.553 79.416h-9.195c-.679 0-1.296.39-1.586 1.003l-4.25 8.997h11.427c.437 0 .83-.267.99-.672l3.297-8.326a.733.733 0 0 0-.683-1.002",
    fill: "url(#aM)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.075 84.03c-.2.617-.052 1.217.329 1.34.38.122.851-.28 1.05-.898s.052-1.218-.328-1.34c-.381-.123-.852.28-1.05.897",
    fill: "url(#aN)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.034 183.683s-.656-4.077 1.349-5.395c.089-.059.208.008.208.114v.775c0 .186.221.281.356.154.432-.406 1.205-1.023 2.023-1.151a.273.273 0 0 1 .296.383c-.503 1.072-1.818 4.076-1.768 6.044z",
    fill: "url(#aO)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.905 183.682-1.343 21.417h8.043V184.28c0-.599-.382-1.129-.95-1.323-1.065-.363-2.874-.816-4.651-.501a1.33 1.33 0 0 0-1.099 1.226",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.926 197.17-.273 5.972a.87.87 0 0 0 .87.908h4.063a.87.87 0 0 0 .871-.869v-5.972a.87.87 0 0 0-.871-.869h-3.791a.87.87 0 0 0-.869.83",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.35 205.098V182.96a1.26 1.26 0 0 0-.888-1.206 9.45 9.45 0 0 0-5.509.018 1.14 1.14 0 0 0-.807 1.09v22.236z",
    fill: "url(#aP)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.859 183.33.174 3.268a.77.77 0 0 0 .768.726h3.857a.77.77 0 0 0 .769-.742l.105-3.225a.77.77 0 0 0-.604-.774c-.937-.202-2.78-.48-4.486-.039a.77.77 0 0 0-.583.786",
    fill: "url(#aQ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.158 188.733a.77.77 0 0 0 .767.714h3.693a.768.768 0 1 0 0-1.534h-3.693a.767.767 0 0 0-.767.82",
    fill: "url(#aR)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.833 183.578.892 21.5h7.619l.577-21.74a1.33 1.33 0 0 0-.94-1.31c-2.477-.742-4.938-.815-7.369.293a1.325 1.325 0 0 0-.779 1.257",
    fill: "url(#aS)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.527 184.385.091 1.169a.653.653 0 0 0 .689.601l6.225-.362a.65.65 0 0 0 .613-.602l.061-.807a.654.654 0 0 0-.652-.701h-6.375a.653.653 0 0 0-.652.702",
    fill: "url(#aT)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.783 187.179v.426c0 .33.275.593.605.579l5.962-.248a.58.58 0 0 0 .557-.579v-.452a.58.58 0 0 0-.607-.579l-5.963.274a.58.58 0 0 0-.554.579",
    fill: "url(#aU)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.983 106.047c8.584-.126 51.042-.868 59.756-1.021a1.537 1.537 0 0 1 1.564 1.535v3.968c0 .847-.688 1.535-1.538 1.535h-59.758c-.85 0-1.538-.687-1.538-1.535v-2.947c0-.839.674-1.523 1.514-1.535",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.805 109.103c0 .863.709 1.559 1.574 1.544l34.626-.599a1.545 1.545 0 0 0 1.476-1.913l-.158-.641a1.55 1.55 0 0 0-1.559-1.176l-34.467 1.241a1.546 1.546 0 0 0-1.492 1.544",
    fill: "#BDD0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.072 109.317-5.324 5.409a.545.545 0 0 0 .039.8l.04.034a.51.51 0 0 0 .718-.065l4.874-5.868z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M159.541 104.984c.823 1.722.066 3.795-1.69 4.632s-3.847.119-4.671-1.602c-.823-1.721-.066-3.795 1.69-4.632s3.848-.119 4.671 1.602",
    fill: "url(#aV)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.702 103.031c-1.955.931-2.796 3.238-1.881 5.154.916 1.915 3.243 2.714 5.198 1.783 1.954-.931 2.796-3.239 1.88-5.154s-3.243-2.714-5.197-1.783m3.073 6.427c-1.667.794-3.652.113-4.434-1.521-.781-1.634-.063-3.602 1.604-4.397 1.668-.794 3.653-.113 4.434 1.521s.063 3.603-1.604 4.397",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.844 107.584a.1.1 0 0 1-.099-.076 3.6 3.6 0 0 1-.124-.759.103.103 0 0 1 .097-.108c.056-.007.105.041.108.097q.021.365.117.716a.1.1 0 0 1-.072.126zm-3.136 6.493a.103.103 0 0 1-.075-.173l.082-.087a.104.104 0 0 1 .145-.005.1.1 0 0 1 .005.145l-.082.087a.1.1 0 0 1-.075.033m66.295 54.643a.21.21 0 0 1-.201-.159 23 23 0 0 0-.145-.593.205.205 0 0 1 .398-.103q.078.3.148.603a.204.204 0 0 1-.2.252m-.547-1.978a.21.21 0 0 1-.196-.143 23 23 0 0 0-.193-.579.204.204 0 0 1 .127-.261.205.205 0 0 1 .261.126q.102.294.197.589a.205.205 0 0 1-.196.268m-.704-1.928a.21.21 0 0 1-.19-.127 26 26 0 0 0-.239-.562.206.206 0 0 1 .376-.165q.126.284.243.571a.205.205 0 0 1-.19.283m-.854-1.866a.2.2 0 0 1-.183-.113 23 23 0 0 0-.283-.542.206.206 0 0 1 .363-.193q.147.274.287.55a.206.206 0 0 1-.184.298m-.996-1.795a.2.2 0 0 1-.177-.099 24 24 0 0 0-.323-.519.205.205 0 0 1 .347-.22q.168.261.328.527a.205.205 0 0 1-.175.311m-1.132-1.713a.2.2 0 0 1-.167-.085q-.179-.249-.362-.493a.205.205 0 0 1 .328-.247q.187.248.368.5a.206.206 0 0 1-.167.325m-1.26-1.621a.2.2 0 0 1-.157-.073 22 22 0 0 0-.399-.464.205.205 0 0 1 .019-.29.207.207 0 0 1 .29.019q.206.233.405.471a.205.205 0 0 1-.158.337m-1.38-1.52a.2.2 0 0 1-.147-.061q-.215-.219-.434-.432a.205.205 0 1 1 .287-.294q.223.216.44.438a.205.205 0 0 1-.146.349m-1.495-1.408a.2.2 0 0 1-.136-.051 25 25 0 0 0-.465-.396.204.204 0 0 1-.027-.289.207.207 0 0 1 .29-.027q.239.2.473.403a.205.205 0 0 1-.135.36m-1.602-1.287a.2.2 0 0 1-.122-.04 25 25 0 0 0-.496-.358.205.205 0 1 1 .237-.336q.253.18.504.364a.206.206 0 0 1-.123.37m-1.7-1.153a.2.2 0 0 1-.108-.031l-.134-.083a19 19 0 0 0-.39-.233.206.206 0 0 1-.073-.281.207.207 0 0 1 .282-.073l.396.237.136.084a.206.206 0 0 1-.109.38m-1.789-1.011a.2.2 0 0 1-.093-.023 23 23 0 0 0-.548-.272.206.206 0 1 1 .179-.37q.28.136.557.277a.205.205 0 0 1-.095.388m-1.864-.863a.2.2 0 0 1-.079-.016 28 28 0 0 0-.568-.228.205.205 0 1 1 .149-.383q.29.112.577.232a.205.205 0 0 1-.079.395m-1.928-.714a.2.2 0 0 1-.063-.01 30 30 0 0 0-.584-.183.205.205 0 1 1 .118-.393q.298.09.593.186a.206.206 0 0 1 .132.259.21.21 0 0 1-.196.141m-14.8-.498a.205.205 0 0 1-.052-.404q.301-.078.604-.149a.206.206 0 0 1 .247.153.206.206 0 0 1-.154.247q-.297.07-.594.146a.2.2 0 0 1-.051.007m12.824-.064a.2.2 0 0 1-.049-.005 24 24 0 0 0-.597-.138.205.205 0 0 1 .088-.401q.304.066.606.14a.205.205 0 0 1-.048.404m-10.816-.372a.206.206 0 0 1-.035-.407q.306-.054.614-.1a.207.207 0 0 1 .234.173.206.206 0 0 1-.173.233q-.303.046-.604.098zm8.801-.036-.033-.002a25 25 0 0 0-.605-.092.205.205 0 1 1 .056-.406q.309.042.615.093a.205.205 0 0 1-.033.407m-6.763-.236a.206.206 0 0 1-.205-.186.207.207 0 0 1 .186-.224q.31-.029.619-.05a.205.205 0 1 1 .029.409q-.305.021-.61.05zm4.723-.017-.018-.001a31 31 0 0 0-.61-.045.206.206 0 0 1-.193-.217.207.207 0 0 1 .218-.192q.31.02.62.045a.206.206 0 0 1-.017.41m-2.67-.094a.205.205 0 0 1-.003-.41q.2-.003.401-.003l.22.001a.205.205 0 1 1-.002.41h-.001l-.217-.001q-.198 0-.395.003zM79.92 163.852a.206.206 0 0 1-.187-.29 26 26 0 0 1 .264-.562.206.206 0 0 1 .275-.096c.102.05.145.173.095.275q-.132.274-.26.553a.21.21 0 0 1-.187.12m.926-1.832a.205.205 0 0 1-.18-.305q.153-.271.31-.538a.205.205 0 1 1 .354.208q-.155.263-.304.53a.2.2 0 0 1-.18.105m1.072-1.75a.2.2 0 0 1-.114-.035.204.204 0 0 1-.056-.284q.172-.258.352-.512a.206.206 0 0 1 .336.236q-.176.25-.346.504a.2.2 0 0 1-.172.091m1.211-1.659a.205.205 0 0 1-.161-.332q.192-.243.391-.482a.206.206 0 0 1 .317.262q-.196.235-.386.475a.2.2 0 0 1-.161.077m1.339-1.557a.205.205 0 0 1-.15-.344q.21-.228.428-.45a.206.206 0 0 1 .294.287 23 23 0 0 0-.422.442.2.2 0 0 1-.15.065m1.458-1.445a.206.206 0 0 1-.139-.357q.23-.21.463-.414a.205.205 0 1 1 .27.309q-.23.201-.455.408a.2.2 0 0 1-.139.054m1.57-1.326a.205.205 0 0 1-.127-.367q.245-.19.495-.376a.206.206 0 0 1 .287.043.205.205 0 0 1-.042.287q-.246.181-.487.37a.2.2 0 0 1-.127.043m1.67-1.195a.206.206 0 0 1-.113-.377q.26-.17.524-.335a.205.205 0 1 1 .217.349q-.26.16-.515.329a.2.2 0 0 1-.113.034m1.763-1.055a.206.206 0 0 1-.099-.386l.115-.061q.217-.117.435-.229a.206.206 0 0 1 .188.365q-.216.111-.429.225l-.112.061a.2.2 0 0 1-.098.025m1.844-.906a.205.205 0 0 1-.083-.393q.284-.126.572-.244a.205.205 0 1 1 .157.379q-.283.117-.563.24a.2.2 0 0 1-.082.018m1.913-.752a.206.206 0 0 1-.068-.399q.293-.102.59-.197a.205.205 0 1 1 .126.391q-.292.093-.58.194a.2.2 0 0 1-.068.011m1.967-.596a.206.206 0 0 1-.052-.404q.3-.077.603-.149a.206.206 0 0 1 .095.4q-.298.069-.595.147a.2.2 0 0 1-.051.006m2.008-.437a.206.206 0 0 1-.036-.408q.306-.053.614-.101a.205.205 0 1 1 .062.406q-.303.046-.604.1zm8.443-.084-.033-.003-.252-.039a.205.205 0 0 1 .06-.406l.257.04a.204.204 0 0 1 .17.235.205.205 0 0 1-.202.173m-6.406-.193a.205.205 0 0 1-.02-.41q.31-.03.62-.052a.207.207 0 0 1 .22.19.207.207 0 0 1-.191.22q-.305.021-.609.051zm4.723-.017h-.019a25 25 0 0 0-.61-.048.206.206 0 0 1-.192-.218.207.207 0 0 1 .219-.191q.31.02.62.048a.205.205 0 0 1-.018.409m-2.671-.098a.205.205 0 0 1-.003-.41c.135-.002.267-.003.406-.003h.216a.205.205 0 0 1-.002.411h-.001l-.214-.001-.398.003zm3.895-17.671-.022-.001-.162-.017a.206.206 0 0 1-.182-.227.207.207 0 0 1 .227-.181l.16.017a.206.206 0 0 1-.021.409m-1.586-.22-.035-.003a21 21 0 0 1-.611-.116.205.205 0 1 1 .081-.402q.3.06.601.113c.111.02.186.126.167.238a.21.21 0 0 1-.203.17m-2.006-.443a.2.2 0 0 1-.054-.007q-.3-.081-.598-.168a.206.206 0 0 1 .116-.394q.294.086.589.165a.205.205 0 0 1-.053.404m-1.961-.615a.2.2 0 0 1-.07-.012 29 29 0 0 1-.582-.219.205.205 0 1 1 .149-.382q.285.11.573.215a.205.205 0 0 1-.07.398m-1.903-.778a.2.2 0 0 1-.085-.018 28 28 0 0 1-.562-.266.205.205 0 1 1 .18-.369q.276.134.553.262a.205.205 0 0 1-.086.391m-1.832-.931a.2.2 0 0 1-.1-.026q-.27-.153-.538-.311a.205.205 0 0 1-.072-.281.206.206 0 0 1 .282-.072q.263.156.53.306a.206.206 0 0 1-.102.384m-1.75-1.076a.2.2 0 0 1-.115-.035 27 27 0 0 1-.511-.353.205.205 0 0 1-.05-.286.207.207 0 0 1 .287-.049q.25.177.504.347a.205.205 0 0 1-.115.376m-1.658-1.212a.2.2 0 0 1-.128-.045q-.243-.194-.482-.392a.206.206 0 0 1 .264-.315q.234.195.474.386c.089.07.103.2.032.288a.2.2 0 0 1-.16.078m-1.556-1.341a.2.2 0 0 1-.14-.056q-.228-.212-.45-.429a.206.206 0 0 1 .289-.293q.218.213.441.423a.205.205 0 0 1-.14.355m-1.443-1.462a.2.2 0 0 1-.152-.067q-.21-.23-.412-.464a.206.206 0 1 1 .31-.269q.202.23.406.457a.205.205 0 0 1-.152.343m-1.319-1.573a.2.2 0 0 1-.163-.081q-.189-.246-.372-.496a.205.205 0 1 1 .332-.242q.18.246.366.489a.204.204 0 0 1-.037.287.2.2 0 0 1-.126.043m-1.182-1.678a.2.2 0 0 1-.174-.094q-.167-.262-.329-.527a.205.205 0 0 1 .07-.282.206.206 0 0 1 .282.069q.159.261.324.518a.206.206 0 0 1-.173.316m-1.035-1.772a.21.21 0 0 1-.183-.11q-.144-.275-.282-.554a.206.206 0 0 1 .37-.181q.135.274.277.544a.205.205 0 0 1-.182.301m-.875-1.857a.21.21 0 0 1-.19-.126q-.104-.249-.203-.501l-.029-.076a.205.205 0 0 1 .384-.147l.029.074q.096.247.198.492a.204.204 0 0 1-.19.284m-.704-1.928a.205.205 0 0 1-.196-.144 22 22 0 0 1-.179-.595.206.206 0 0 1 .395-.112q.085.293.176.584a.206.206 0 0 1-.196.267m-.529-1.982a.206.206 0 0 1-.2-.161 24 24 0 0 1-.126-.609.205.205 0 1 1 .404-.077q.058.3.123.597a.206.206 0 0 1-.2.25m-.354-2.021a.206.206 0 0 1-.204-.179 25 25 0 0 1-.073-.616.206.206 0 0 1 .41-.044q.031.305.071.606a.206.206 0 0 1-.204.233m-.182-2.044c-.11 0-.2-.086-.205-.196q-.015-.31-.022-.62a.206.206 0 0 1 .201-.21h.005c.111 0 .203.089.205.201q.007.305.021.61a.206.206 0 0 1-.195.215zm-.013-2.052h-.007a.205.205 0 0 1-.199-.212q.011-.31.03-.62a.203.203 0 0 1 .217-.193c.113.007.2.104.193.217q-.018.305-.028.61a.206.206 0 0 1-.206.198m.154-2.046-.024-.001a.206.206 0 0 1-.18-.228q.035-.308.078-.615a.205.205 0 1 1 .407.057q-.042.302-.077.605a.205.205 0 0 1-.204.182m.317-2.027a.205.205 0 0 1-.202-.245q.06-.304.127-.607a.205.205 0 0 1 .402.089q-.067.298-.126.598a.206.206 0 0 1-.201.165m.478-1.995a.205.205 0 0 1-.198-.261q.084-.3.176-.596a.205.205 0 0 1 .393.121q-.09.292-.174.586a.205.205 0 0 1-.197.15m.637-1.95a.205.205 0 0 1-.193-.277q.108-.292.224-.58a.206.206 0 0 1 .382.153q-.114.284-.22.57a.21.21 0 0 1-.193.133m.794-1.893a.205.205 0 0 1-.186-.292q.132-.281.27-.56a.206.206 0 0 1 .369.184q-.136.273-.267.55a.2.2 0 0 1-.186.118m.95-1.82a.205.205 0 0 1-.179-.307q.156-.27.318-.534a.206.206 0 0 1 .35.214q-.16.26-.311.524a.2.2 0 0 1-.179.103m1.1-1.732a.205.205 0 0 1-.168-.323q.178-.255.363-.504a.206.206 0 0 1 .33.243q-.18.246-.356.496a.2.2 0 0 1-.168.088m1.25-1.629a.205.205 0 0 1-.157-.337q.2-.239.406-.47a.206.206 0 0 1 .308.272q-.202.228-.4.462a.2.2 0 0 1-.157.073m49.762 21.919a.206.206 0 0 1-.205-.194l-.005-.104a.206.206 0 0 1 .196-.215.21.21 0 0 1 .215.196l.005.101a.206.206 0 0 1-.195.216zm-.026-1.539h-.004a.205.205 0 0 1-.202-.209q.005-.31.019-.62a.206.206 0 0 1 .411.018q-.014.305-.019.609a.205.205 0 0 1-.205.202m.127-2.047-.022-.001a.205.205 0 0 1-.182-.226q.033-.31.074-.617a.205.205 0 0 1 .408.055q-.04.302-.074.605a.205.205 0 0 1-.204.184m.309-2.029a.205.205 0 0 1-.202-.245q.06-.304.129-.607a.206.206 0 1 1 .401.09 20 20 0 0 0-.126.597.206.206 0 0 1-.202.165m.485-1.993a.2.2 0 0 1-.057-.009.205.205 0 0 1-.141-.254q.086-.299.18-.594a.207.207 0 0 1 .259-.134c.108.035.168.15.133.258q-.092.291-.177.584a.21.21 0 0 1-.197.149m.654-1.945a.205.205 0 0 1-.192-.279q.112-.29.231-.577a.206.206 0 0 1 .38.157 23 23 0 0 0-.227.567.205.205 0 0 1-.192.132m.819-1.882a.205.205 0 0 1-.185-.295q.137-.279.279-.555a.207.207 0 0 1 .278-.088c.101.052.14.176.088.277q-.141.271-.275.545a.21.21 0 0 1-.185.116m.978-1.805a.206.206 0 0 1-.177-.31q.16-.267.327-.529a.205.205 0 1 1 .347.22q-.164.258-.321.52a.2.2 0 0 1-.176.1m1.131-1.712a.204.204 0 0 1-.166-.326q.182-.252.371-.498a.205.205 0 1 1 .327.25q-.186.242-.365.489a.2.2 0 0 1-.167.085m1.279-1.607a.205.205 0 0 1-.155-.34q.204-.234.415-.462a.205.205 0 1 1 .303.278q-.207.224-.408.454a.2.2 0 0 1-.155.07m1.42-1.483a.205.205 0 0 1-.142-.354q.225-.213.456-.422a.205.205 0 1 1 .276.305q-.228.204-.448.414a.2.2 0 0 1-.142.057m1.55-1.347a.2.2 0 0 1-.161-.077.206.206 0 0 1 .033-.288q.244-.195.493-.38a.205.205 0 1 1 .247.328q-.244.184-.484.373a.2.2 0 0 1-.128.044m1.666-1.202a.205.205 0 0 1-.113-.377q.26-.17.524-.335a.206.206 0 0 1 .217.35q-.26.16-.515.328a.2.2 0 0 1-.113.034m1.765-1.052a.205.205 0 0 1-.098-.386q.273-.147.551-.288a.205.205 0 0 1 .186.366q-.273.138-.542.283a.2.2 0 0 1-.097.025m1.849-.896a.205.205 0 0 1-.082-.394q.286-.123.574-.239a.206.206 0 1 1 .154.38q-.284.115-.565.236a.2.2 0 0 1-.081.017m1.919-.734a.205.205 0 0 1-.065-.4q.294-.1.592-.19a.206.206 0 0 1 .121.393q-.293.09-.582.186a.2.2 0 0 1-.066.01m1.975-.568a.206.206 0 0 1-.2-.157.206.206 0 0 1 .152-.248q.303-.072.607-.138a.206.206 0 0 1 .086.402q-.299.064-.596.135a.2.2 0 0 1-.049.006m2.017-.395a.205.205 0 0 1-.03-.408q.307-.047.616-.085a.205.205 0 0 1 .051.407 23 23 0 0 0-.637.086m2.044-.217a.205.205 0 0 1-.012-.41q.31-.02.621-.03a.205.205 0 1 1 .014.41 23 23 0 0 0-.623.03m2.672-.007h-.012q-.305-.017-.61-.027a.206.206 0 1 1 .012-.41q.31.009.622.027a.205.205 0 0 1-.012.41M148.03 192.343l-.018-.001a5 5 0 0 1-.634-.095.205.205 0 0 1 .085-.402q.299.063.585.088a.205.205 0 0 1-.018.41m1.426-.121a.206.206 0 0 1-.056-.403q.282-.078.542-.205a.205.205 0 1 1 .18.369q-.294.142-.61.231a.2.2 0 0 1-.056.008m-3.398-.425a.2.2 0 0 1-.084-.018 9 9 0 0 1-.566-.281.206.206 0 0 1-.083-.279.206.206 0 0 1 .279-.082q.27.146.539.268c.103.046.149.168.103.271a.21.21 0 0 1-.188.121m-1.761-1.052a.2.2 0 0 1-.122-.041 13 13 0 0 1-.495-.383.205.205 0 1 1 .259-.318q.238.193.48.371a.204.204 0 0 1 .043.287.2.2 0 0 1-.165.084m-1.555-1.34a.2.2 0 0 1-.145-.061 14 14 0 0 1-.433-.451.205.205 0 0 1 .304-.277q.206.224.42.438a.206.206 0 0 1-.146.351m-1.341-1.553a.2.2 0 0 1-.165-.083 14 14 0 0 1-.363-.509.205.205 0 1 1 .34-.23q.171.25.353.494a.206.206 0 0 1-.165.328m-1.104-1.729a.2.2 0 0 1-.181-.108q-.15-.275-.286-.556a.205.205 0 1 1 .37-.179q.133.273.277.54a.205.205 0 0 1-.18.303m-.843-1.87a.205.205 0 0 1-.193-.135 15 15 0 0 1-.202-.592.205.205 0 0 1 .393-.123q.09.29.195.574a.204.204 0 0 1-.123.263.2.2 0 0 1-.07.013m-.557-1.974a.204.204 0 0 1-.201-.165 14 14 0 0 1-.109-.615.204.204 0 0 1 .172-.234.205.205 0 0 1 .234.171q.047.302.106.597a.205.205 0 0 1-.202.246m-.252-2.035a.206.206 0 0 1-.205-.195q-.015-.312-.016-.625a.205.205 0 1 1 .411-.001q.001.303.016.606a.205.205 0 0 1-.195.215zm.051-2.05-.02-.001a.205.205 0 0 1-.184-.224q.03-.31.073-.62a.206.206 0 0 1 .408.057q-.043.3-.072.603a.205.205 0 0 1-.205.185m.346-2.021a.205.205 0 0 1-.2-.254q.074-.304.162-.603a.206.206 0 0 1 .395.115q-.086.29-.158.586a.206.206 0 0 1-.199.156m.633-1.95a.206.206 0 0 1-.191-.283q.12-.292.249-.574a.207.207 0 0 1 .273-.1.205.205 0 0 1 .101.272q-.126.273-.242.556a.205.205 0 0 1-.19.129",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 33.936,
    y1: 130.665,
    x2: 252.591,
    y2: 130.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 138.825,
    y1: 62.808,
    x2: 135.65,
    y2: 193.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 138.385,
    y1: 108.555,
    x2: 135.845,
    y2: 223.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 136.878,
    y1: 126.549,
    x2: 138.783,
    y2: 190.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 138.074,
    y1: 159.311,
    x2: 133.839,
    y2: 222.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 139.629,
    y1: 159.415,
    x2: 135.394,
    y2: 223.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 177.492,
    y1: 159.132,
    x2: 176.645,
    y2: 198.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 177.088,
    y1: 159.123,
    x2: 176.241,
    y2: 198.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 219.532,
    y1: 72.941,
    x2: 212.401,
    y2: 72.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 219.597,
    y1: 74.219,
    x2: 212.395,
    y2: 74.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 214.269,
    y1: 74.316,
    x2: 212.273,
    y2: 87.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 231.145,
    y1: 78.985,
    x2: 222.651,
    y2: 78.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 231.509,
    y1: 78.673,
    x2: 223.24,
    y2: 78.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 223.732,
    y1: 75.789,
    x2: 221.736,
    y2: 88.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 212.884,
    y1: 87.851,
    x2: 217.437,
    y2: 67.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 215.642,
    y1: 76.339,
    x2: 204.787,
    y2: 97.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 182.036,
    y1: 70.921,
    x2: 198.722,
    y2: 138.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 181.366,
    y1: 78.736,
    x2: 187.514,
    y2: 87.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 168.774,
    y1: 89.633,
    x2: 182.047,
    y2: 100.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 175.008,
    y1: 51.059,
    x2: 177.354,
    y2: 62.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 180.206,
    y1: 67.497,
    x2: 177.973,
    y2: 78.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 177.18,
    y1: 50.616,
    x2: 179.527,
    y2: 62.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 191.898,
    y1: 75.178,
    x2: 187.237,
    y2: 85.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 329.403,
    y1: 152.566,
    x2: 308.574,
    y2: 142.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 328.276,
    y1: 154.973,
    x2: 307.447,
    y2: 145.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 171.673,
    y1: 86.217,
    x2: 184.946,
    y2: 97.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 174.3,
    y1: 81.835,
    x2: 170.911,
    y2: 90.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 172.623,
    y1: 85.609,
    x2: 170.125,
    y2: 89.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 169.3,
    y1: 88.192,
    x2: 167.235,
    y2: 88.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 75.245,
    y1: 186.861,
    x2: 82.449,
    y2: 173.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 70.85,
    y1: 198.915,
    x2: 72.171,
    y2: 219.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 76.277,
    y1: 202.674,
    x2: 78.606,
    y2: 189.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 68.587,
    y1: 199.201,
    x2: 65.181,
    y2: 186.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 83.647,
    y1: 198.082,
    x2: 84.968,
    y2: 218.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 65.823,
    y1: 166.141,
    x2: 55.745,
    y2: 188.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 65.58,
    y1: 167.6,
    x2: 66.528,
    y2: 161.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 200.3,
    y1: 10.441,
    x2: 194.116,
    y2: 17.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 125.509,
    y1: 400.683,
    x2: 128.467,
    y2: 413.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 198.281,
    y1: 8.67,
    x2: 192.097,
    y2: 15.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 65.421,
    y1: 168.84,
    x2: 61.291,
    y2: 181.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 153.62,
    y1: 399.059,
    x2: 158.306,
    y2: 411.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 59.777,
    y1: 176.316,
    x2: 70.859,
    y2: 179.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 75.006,
    y1: 169.061,
    x2: 82.973,
    y2: 177.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 79.833,
    y1: 171.158,
    x2: 83.446,
    y2: 176.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 42.617,
    y1: 181.208,
    x2: 102.134,
    y2: 181.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 215.629,
    y1: 172.567,
    x2: 230.549,
    y2: 196.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 196.535,
    y1: 190.038,
    x2: 204.932,
    y2: 190.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 189.25,
    y1: 204.97,
    x2: 196.933,
    y2: 204.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 195.885,
    y1: 191.594,
    x2: 204.932,
    y2: 191.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 188.096,
    y1: 206.626,
    x2: 195.042,
    y2: 206.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 208.012,
    y1: 176.264,
    x2: 222.415,
    y2: 176.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 226.843,
    y1: 175.242,
    x2: 215.512,
    y2: 215.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 228.21,
    y1: 167.402,
    x2: 227.39,
    y2: 160.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 226.161,
    y1: 150.556,
    x2: 223.832,
    y2: 162.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 232.469,
    y1: 151.839,
    x2: 230.14,
    y2: 163.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 237.949,
    y1: 152.952,
    x2: 235.619,
    y2: 164.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 205.978,
    y1: 172.512,
    x2: 212.131,
    y2: 172.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 220.427,
    y1: 186.738,
    x2: 219.528,
    y2: 178.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 228.372,
    y1: 157.149,
    x2: 221.897,
    y2: 161.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 217.201,
    y1: 164.881,
    x2: 231.14,
    y2: 153.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 226.259,
    y1: 163.23,
    x2: 228.268,
    y2: 157.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 166.103,
    y1: 167.527,
    x2: 159.716,
    y2: 177.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 162.913,
    y1: 178.23,
    x2: 164.875,
    y2: 237.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 151.514,
    y1: 183.773,
    x2: 164.522,
    y2: 215.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A22B25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0423C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 174.65,
    y1: 183.705,
    x2: 161.642,
    y2: 215.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A22B25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0423C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 163.107,
    y1: 187.86,
    x2: 162.433,
    y2: 215.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 162.948,
    y1: 191.252,
    x2: 163.69,
    y2: 174.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 170.939,
    y1: 204.339,
    x2: 178.071,
    y2: 204.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 175.646,
    y1: 191.505,
    x2: 168.143,
    y2: 211.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A22B25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0423C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 153.632,
    y1: 204.304,
    x2: 146.499,
    y2: 204.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 160.566,
    y1: 185.372,
    x2: 153.059,
    y2: 205.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A22B25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0423C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 167.106,
    y1: 197.222,
    x2: 175.156,
    y2: 177.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 162.366,
    y1: 189.291,
    x2: 158.977,
    y2: 202.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 162.972,
    y1: 186.371,
    x2: 162.799,
    y2: 171.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4421B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C0E16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 162.467,
    y1: 178.001,
    x2: 165.105,
    y2: 165.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A22B25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0423C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 165.841,
    y1: 167.358,
    x2: 159.511,
    y2: 177.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 159.805,
    y1: 179.438,
    x2: 161.277,
    y2: 158.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A22B25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0423C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 100.622,
    y1: 96.28,
    x2: 89.388,
    y2: 113.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aA",
    x1: 107.576,
    y1: 102.02,
    x2: 99.911,
    y2: 120.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aB",
    x1: 87.34,
    y1: 82.67,
    x2: 95.389,
    y2: 105.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aC",
    x1: 104.594,
    y1: 106.866,
    x2: 93.327,
    y2: 123.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aD",
    x1: 74.002,
    y1: 92.066,
    x2: 96.303,
    y2: 92.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aE",
    x1: 74.732,
    y1: 71.087,
    x2: 87.942,
    y2: 71.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aF",
    x1: 90.303,
    y1: 73.723,
    x2: 50.133,
    y2: 112.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aG",
    x1: 65.875,
    y1: 93.923,
    x2: 82.016,
    y2: 86.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aH",
    x1: 87.895,
    y1: 67.115,
    x2: 84.082,
    y2: 77.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aI",
    x1: 338.307,
    y1: -22.957,
    x2: 328.193,
    y2: -19.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aJ",
    x1: 85.344,
    y1: 66.37,
    x2: 93.037,
    y2: 66.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aK",
    x1: 337.56,
    y1: -24.975,
    x2: 327.446,
    y2: -21.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aL",
    x1: 80.688,
    y1: 86.494,
    x2: 89.45,
    y2: 89.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aM",
    x1: 103.776,
    y1: 85.065,
    x2: 23.767,
    y2: 78.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aN",
    x1: 96.544,
    y1: 82.416,
    x2: 99.401,
    y2: 86.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aO",
    x1: 118.932,
    y1: 181.391,
    x2: 123.292,
    y2: 181.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aP",
    x1: 124.146,
    y1: 193.225,
    x2: 131.35,
    y2: 193.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aQ",
    x1: 128.797,
    y1: 181.048,
    x2: 137.532,
    y2: 151.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aR",
    x1: 129.943,
    y1: 181.389,
    x2: 138.679,
    y2: 151.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aS",
    x1: 125.998,
    y1: 169.824,
    x2: 102.061,
    y2: 208.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aT",
    x1: 112.002,
    y1: 169.965,
    x2: 111.684,
    y2: 177.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aU",
    x1: 112.11,
    y1: 169.97,
    x2: 111.792,
    y2: 177.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aV",
    x1: 153.18,
    y1: 108.014,
    x2: 159.536,
    y2: 104.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRequest);
export default __webpack_public_path__ + "static/media/noRequest.06a3a8fbd3412f54eba470806ddc6916.svg";
export { ForwardRef as ReactComponent };